import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f721772")

_pushScopeId("data-v-4f721772")
const _hoisted_1 = { class: "p-col-6" }
const _hoisted_2 = { class: "p-col-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.specimen, (item, key) => {
    return (_openBlock(), _createBlock("div", {
      key: key,
      class: "p-d-flex p-flex-column p-flex-md-row"
    }, [
      _createVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_Button, {
          class: ["tooltipButton formBox", { required: item.required, notRequired: !item.required }]
        }, {
          default: _withId(() => [
            _createVNode(_component_info_button),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
          ]),
          _: 2
        }, 1032, ["class"]), [
          [
            _directive_tooltip,
            _ctx.$t(item.help),
            void 0,
            { right: true }
          ]
        ])
      ]),
      _createVNode("div", _hoisted_2, [
        (item.component === _ctx.ComponentEnum.CategoryPicker)
          ? (_openBlock(), _createBlock(_component_category_picker, {
              key: 0,
              name: item.name,
              api: item.api,
              value: item.value == null ? item.defaultValue : item.value,
              onSelect: _ctx.select,
              filter: item.filter,
              clearable: item.clearable
            }, null, 8, ["name", "api", "value", "onSelect", "filter", "clearable"]))
          : (_openBlock(), _createBlock(_component_string_picker, {
              key: 1,
              onSelect: _ctx.select,
              value: item.value,
              name: item.name,
              placeholder: _ctx.$t(item.placeholder)
            }, null, 8, ["onSelect", "value", "name", "placeholder"]))
      ])
    ]))
  }), 128))
})